module.exports = __webpack_public_path__ + "static/media/12.Welding-Rectifier.115c82e1.webp";